import zh_CN from "./zh-CN/index";
import en_US from "./en-US/index";

export default {
    zh_CN,
    en_US,
};
